var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crown_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.555 7.027a1.1 1.1 0 0 0-.668 1.97l-2.13 1.741-2.292-3.972a1.102 1.102 0 1 0-1.453-1.032A1.1 1.1 0 0 0 9.8 6.781l-2.317 4.012-2.293-1.875a1.1 1.1 0 0 0-.766-1.902 1.1 1.1 0 0 0-1.089 1.113 1.1 1.1 0 0 0 1.398 1.05l.907 4.087a.53.53 0 0 0 .52.418h7.863a.528.528 0 0 0 .52-.418l.886-4.043a1.1 1.1 0 0 0 1.234-1.105 1.095 1.095 0 0 0-1.11-1.09ZM14.176 14.328H5.984a.266.266 0 0 0-.265.266v.515c0 .149.12.266.265.266h8.192a.266.266 0 0 0 .265-.266v-.515a.268.268 0 0 0-.265-.266Z",
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crown_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCrown;